module.exports = __webpack_public_path__ + "static/portfolio-2-540ffad84dac6240524f4fc3979004a0.jpg";